////////////////////////////////////////////////////////////////////////////////////
// MODULE IMPORTS:
////////////////////////////////////////////////////////////////////////////////////

import Parallax from 'parallax-js';
var popup = require("jquery-popup-overlay");
import hyperform from 'hyperform'; // used in form.all.js

window.hyperform = hyperform;

////////////////////////////////////////////////////////////////////////////////////
// GLOBAL VARS:
////////////////////////////////////////////////////////////////////////////////////
var ww; // window width
var wh; // window width
var hh;
var selectedClassName = 'selected'; // the selected class name for menu items
var menuOpenClassName = 'open'; // the class that defines the open state of the menu
var fadeInSpeed = 50; // the fade in transition speed
var fadeOutSpeed = 75; // the fade out transition speed
var navMouseOutDelay = 600; // the delay before the nav disappears on mouseout
var mouseOutTimer; // the MouseOut timeout timer 
var is_responsive = false;
var $header;
var lastScrollTop = 0; // used for tracking scroll position and direction
var scrollDirection = "down"; // default

function refreshScrollData() {
  // Gets the scrollTop and direction and updates the global variables accordingly
  var st = window.pageYOffset || document.documentElement.scrollTop;
  if (st > lastScrollTop) {
    scrollDirection = "down";
  } else {
    scrollDirection = "up";
  }
  lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function refreshDimensions() {
  // update calculated dimensions (to be used on resize events, or anytime a manual refresh is required)
  ww = document.documentElement.clientWidth;
  wh = document.documentElement.clientHeight;
  hh = $("header").outerHeight();

  // Update CSS variables (custom properties)
  var root = document.documentElement;
  root.style.setProperty('--header-height', hh + "px");

  // ### Check if we are in Mobile (ie Responsive mode)
  if ($('.mobileHeader').css('display') === 'block') {
    is_responsive = true;
  } else {
    is_responsive = false;
  }

  //$("main").eq(0).css({
  //    paddingTop: hh + "px"
  //});

  //refreshScrollbarWidthValue();
  refreshForcedWidthContainers();
  refreshScrollData(); // refresh scroll data just in case...
}

////////////////////////////////////////////////////////////////////////////////////
// MAIN DOCUMENT READY
////////////////////////////////////////////////////////////////////////////////////

window.addEventListener('DOMContentLoaded', function () {
  $header = $("#wrapper > header");
  refreshDimensions();
  $(window).trigger('resize');
});
if (isSitefinityEditor()) {
  $("body").addClass("loaded");
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////
/// SMOOTH PAGE TRANSITIONS / LOADING SPINNERS
//////////////////////////////////////////////////////////////////////////////////////////////////////////

// Page loading spinner animation
if (isSitefinityEditor()) {
  $("body").addClass("loaded");
}
window.destinationUrl = ""; // explicit global declaration

$(document).ready(function () {
  // Add a "loaded" class when the document is finshed loading
  $("body").addClass("loaded");
  $("body").removeClass("loading");

  // Revert to initial state
  window.onbeforeunload = function () {
    if (!isExternal(destinationUrl)) {
      $("body").addClass("unloading");
      $("body").removeClass("loaded");
    }
  };
});

// store the destination url to be used for page loading animation logic
$(document).on("click", "a[href]", function (event) {
  destinationUrl = $(this).attr("href");
});

////////////////////////////////////////////////////////////////////////////////////
// STICKY HEADER
////////////////////////////////////////////////////////////////////////////////////
//window.addEventListener('DOMContentLoaded', function () {
//    var sticky = new Waypoint.Sticky({
//        element: $('header')[0]
//    });
//});

////////////////////////////////////////////////////////////////////////////////////
// SCROLL EVENTS
////////////////////////////////////////////////////////////////////////////////////

var hasRunCountUpAnimation = false;
if ($(".factGroup").length) {
  var waypoint = new Waypoint({
    element: $(".factGroup").get(0),
    //document.getElementById('waypoint'),
    handler: function handler() {
      if (!hasRunCountUpAnimation) {
        var $countUpInstances = $(".countUp");
        if ($countUpInstances.length) {
          $countUpInstances.each(function () {
            var $countUpInstance = $(this);
            var startVal = $countUpInstance.data("start-value");
            var endVal = $countUpInstance.data("end-value");
            numAnim = new CountUp($countUpInstance.attr("id"), startVal, endVal);
            if (!numAnim.error) {
              numAnim.start();
            } else {
              console.error(numAnim.error);
            }
          });
          hasRunCountUpAnimation = true;
        }
      }
    },
    offset: "60%"
  });
}

////////////////////////////////////////////////////////////////////////////////////
// SCROLL-TO-TOP BUTTON
////////////////////////////////////////////////////////////////////////////////////

$(window).on("scroll", function () {
  $header = $("#wrapper > header");
  refreshScrollData();

  // Scroll-to-top link
  if (lastScrollTop > 450) {
    $('.scrollToTop').fadeIn();
  } else {
    $('.scrollToTop').fadeOut();
  }
  $("body").removeClass("down up").addClass(scrollDirection);
  $header.removeClass("down up").addClass(scrollDirection);
  if (lastScrollTop === 0) {
    $("body").addClass("top");
    $header.addClass("top");
  } else {
    $header.removeClass("top");
    $("body").removeClass("top");
  }
});
$(document).ready(function () {
  // stick the scroll-to-top bottom in position above the footer to prevent overlapping and messiness
  var waypoint = new Waypoint({
    offset: "bottom-in-view",
    element: $("#wrapper"),
    handler: function handler(direction) {
      // bottom of the main wrapper has been hit
      if (direction === "up") {
        $(".scrollToTop").removeClass("stuck");
      } else {
        $(".scrollToTop").addClass("stuck");
      }
    }
  });
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////
/// SCROLL TO LOCATION ON PAGE
//////////////////////////////////////////////////////////////////////////////////////////////////////////

$('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function (event) {
  if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    if (target.length) {
      event.preventDefault();
      $('html, body').animate({
        scrollTop: target.offset().top - 250
      }, 1000, function () {
        var $target = $(target);
        $target.focus();
        if ($target.is(":focus")) {
          return false;
        } else {
          $target.attr('tabindex', '-1');
          $target.focus();
        }
        ;
      });
    }
  }
});

/*window.addEventListener('DOMContentLoaded', function () {

    function scrollToLocation(scrollTo, animate, speed) {
        speed = (typeof speed !== 'undefined') ? speed : 2500;
        animate = (typeof animate !== 'undefined') ? animate : true;
        scrollTo = $(scrollTo);
        var container = $('html, body');
        if (animate) {
            container.animate({
                scrollTop: scrollTo.offset().top - container.offset().top + container.scrollTop()
            }, speed);
        } else {
            // Required so that element on page is loaded
            setTimeout(function () {
                container.scrollTop(
                    scrollTo.offset().top - container.offset().top + container.scrollTop()
                );
            }, 2250);
        }
    }
});
*/
// ###### Scroll to Tab Content
// ### Click event for the "Scroll to Tab" for TabStrip (works for all RadTabs)
$(document).on("click", ".RadTabStrip a.rtsLink", function () {
  if (is_responsive) {
    scrollToAnchorTab();
  }
});
// ### "Scroll to Tab Content function
function scrollToAnchorTab() {
  var aTag = $(".tabContainer"); // need to add this class "tabContainer" on any manually added RadMultiPage
  $('html,body').animate({
    scrollTop: aTag.offset().top
  }, 'slow');
}

// ###### Scroll to Top
// ### Check to see if the window is top if not then display "Scroll to Top" button
// ### Click event for the "Scroll to Top" button
$(document).on('click', '.scrollToTop', function () {
  $('html, body').animate({
    scrollTop: 0
  }, 800);
  return false;
});

////////////////////////////////////////////////////////////////////////////////////
// WINDOW RESIZING
////////////////////////////////////////////////////////////////////////////////////

$(window).on('resize', function () {
  refreshDimensions();
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////
// SLIDERS / CAROUSELS (NOTE: it's probably better to add these in the slider View)
//////////////////////////////////////////////////////////////////////////////////////////////////////////

// ToDo: move these into their respective Views

// GLOBAL SLIDER SETTINGS
$(".slick-slider > button").on("click", function () {
  $(this).closest(".slick-slider").slick('slickPause');
  scrollUpDown1px();
});
$('.slick-slider').on('swipe', function () {
  $(this).slick('slickPause');
  scrollUpDown1px();
});

// GLOBAL CONFIG OBJECT FOR SLICK
// note: you will need to manually reference this object on slider creation.
window.GlobalSlickConfig = {
  rows: 0,
  accessibility: true,
  prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0"><span class="sr-only">Previous</span></button>',
  nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0"><span class="sr-only">Next</span></button>'
};

//$("*").on("init", function (event, slick) {

//    var $slider = $(event.target);

//    if ($slider.slick) {
//        $slider.slick('slickSetOption', {
//            rows: 0, 
//            nextArrow: '<button type="button" class="slick-next">Next Slide</button>'
//        }, true);
//    }

//    console.log("initialized! ");
//    console.log("slick: ", $slider);

//});

/////////////////////////////////////////////////////////
//// AOS
//// looks for items with data-aos="animation_name" attribute
//// usage: <div data-aos="animation_name">
//// credit: https://github.com/michalsnik/aos
/////////////////////////////////

//var staggerme = $("[data-aos-stagger=true]");
//var staggerCounter = 0;
//staggerme.each(function () {

//    $(this).attr("data-aos-delay", staggerCounter);
//    staggerCounter += 100;
//});

//AOS.init();

//////////////////////////////////////////////////////////////////////////////////////////////////////////
///SEARCH BOX FUNCTIONALITY
//////////////////////////////////////////////////////////////////////////////////////////////////////////

//$(function () {
//    var searchWrapper = $('.sfsearchBox');
//    var searchInput = searchWrapper.find('input[name="search"]');
//    var searchIndex = searchWrapper.find('input[id="hdnSearchIndex"]');
//    var searchLocation = searchWrapper.find('input[id="hdnSearchLocation"]');
//    var searchButton = searchWrapper.find('button');

//    searchButton.click(function (e) {
//        e.preventDefault();

//        var index = searchIndex.val();
//        var value = searchInput.val().trim();
//        var location = searchLocation.val().trim();
//        if (index && value !== '' && location !== '') {
//            window.location = location
//                + '?indexCatalogue='
//                + index + '&searchQuery='
//                + value + '&wordsMode=0';
//        }
//    });

//    searchInput.keypress(function (e) {
//        var key = e.which;

//        // the enter key code
//        if (key === 13) {
//            searchButton.click();
//            return false;
//        }
//    });
//});

//////////////////////////////////////////////////////////////////////////////////////////////////////////
/// Counters (using jquery.counter-up.js and waypoints)
//////////////////////////////////////////////////////////////////////////////////////////////////////////

window.addEventListener('DOMContentLoaded', function () {
  var $counters = $('.counter');
  if ($counters.length) {
    $counters.each(function (i, counter) {
      // No need to call waypoints manually ... the counter-up plugin has the call built-in
      $(counter).counterUp({
        delay: 20,
        time: 2000
      });
    });
  }
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////
/// LAZY   http://jquery.eisbehr.de/lazy/
//////////////////////////////////////////////////////////////////////////////////////////////////////////
$('.lazy').lazy({
  threshold: 0 // images will load when 100 px from viewport edge
});

// Needed for lazy loading in some sliders to load images on click/swipe of next slide
function scrollUpDown1px() {
  setTimeout(function () {
    $(window).scrollTop($(window).scrollTop() - 1);
    $(window).scrollTop($(window).scrollTop() + 1);
  }, 250);
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////
/// FORMS / AUTO-FILL
//////////////////////////////////////////////////////////////////////////////////////////////////////////

// SEARCH BOX - PLACEHOLDER TEXT
$('.search input[type="text"]').attr("placeholder", "How Can We Help You?");

// Fix for Chrome Form Autofill for our contact form
$(".contactForm input[name*=Name]").attr('autocomplete', 'name');
$(".contactForm input[name*=Email]").attr('autocomplete', 'email');
$(".contactForm input[name*=Phone]").attr('autocomplete', 'tel');
// Or you could turn it off
//$('form').attr('autocomplete', 'off');

//////////////////////////////////////////////////////////////////////////////////////////////////////////
// Misc
//////////////////////////////////////////////////////////////////////////////////////////////////////////

// Check if sitefinity page editor is open
function isSitefinityEditor() {
  return $("body").hasClass("sfPageEditor");
}

// Clickable items (e.g. a clickable article card with nested links)
$(document).on("click", ".clickable", function (event) {
  var $this = $(this);

  // If there's not data-url, then find the first child el with an href and use that
  var itemUrl = "";
  var target = "_self"; // default

  // First check for data atts. If none, use the first child link
  if (typeof $this.data("url") !== 'undefined' && $this.data("url").length) {
    itemUrl = $this.data("url");
    if (typeof $this.data("target") !== 'undefined' && $this.data("target").length) {
      target = $this.data("target");
    }
  } else {
    var $firstLinkFound = $this.find("a[href]").first();
    itemUrl = $firstLinkFound.attr("href");
    target = $firstLinkFound.attr("target") ? $firstLinkFound.attr("target") : target;
  }
  window.open(itemUrl, target);
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////
// CONTAINER CALCULATIONS
//////////////////////////////////////////////////////////////////////////////////////////////////////////

function refreshScrollbarWidthValue() {
  var scrollbarWidth = 16; // px (standard measured manually on Chrome)

  try {
    scrollbarWidth = getScrollbarWidth();
  } catch (_unused) {
    console.log("unable to calculate scrollbar width automatically.");
  }
}
function refreshForcedWidthContainers() {
  var scrollbarWidth = 16; // px (standard measured manually on Chrome)
  try {
    scrollbarWidth = getScrollbarWidth();
    console.log({
      scrollbarWidth: scrollbarWidth
    });
  } catch (_unused2) {
    console.log("unable to calculate scrollbar width automatically.");
  }
  var width = "calc(100vw - " + scrollbarWidth + "px)";
  var $forcedWidthContainers = $(".container.force");
  $forcedWidthContainers.each(function () {
    //debugger;
    var $scrollParent = $(this).scrollParent();
    if ($scrollParent && $scrollParent.length) {
      //$(this).css({
      //    maxWidth: width
      //});
    }
  });
  // ToDo: try doing this with a custom property instead:
  var root = document.documentElement;
  root.style.setProperty('--scrollbar-width', scrollbarWidth + "px");
}
function getScrollbarWidth() {
  // Creating invisible container
  var outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // forcing scrollbar to appear
  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
  document.body.appendChild(outer);

  // Creating inner element and placing it in the container
  var inner = document.createElement('div');
  outer.appendChild(inner);

  // Calculating difference between container's full width and the child width
  var scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  // Removing temporary elements from the DOM
  outer.parentNode.removeChild(outer);
  return scrollbarWidth;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////
/// Resize Items based on the content inside them. Useful for sliders so that items remain same height
/// called like in window resize event: resizeItemsVertically($('.servicesList'), $('.servicesList .items .item .bottom'));
//////////////////////////////////////////////////////////////////////////////////////////////////////////
function resizeItemsVertically(baseElement, itemHeightElement) {
  if (baseElement.length > 0) {
    // check for element
    var itemsMaxHeight = 0;
    itemHeightElement.each(function () {
      var thisItemHeight = $(this).height();
      if (thisItemHeight > itemsMaxHeight) {
        itemsMaxHeight = thisItemHeight;
      }
    });
    itemHeightElement.height(itemsMaxHeight);
  }
}

// Clear Text Selection
function clearSelection() {
  if (document.selection) {
    document.selection.empty();
  } else if (window.getSelection) {
    window.getSelection().removeAllRanges();
  }
}

// Parallax
//$('.relatedItems').parallax({ imageSrc: 'http://localhost:10165/images/default-source/default-album/bearb60534826168616da574ff000044313a.png?sfvrsn=326d55d5_0' });

// Email link warning message
//window.addEventListener('DOMContentLoaded', function () {
//    $('a[href^="mailto"]').on("click", function () {
//        return confirm("Sending an e-mail to us will not make us your lawyers.  Please do not include any confidential information in your e-mail.");
//    });
//});

// accordianUL 
window.addEventListener('DOMContentLoaded', function () {
  var groupClass = "group";
  var expandedClass = "active";
  $(".accordionUL span.toggle").on("click", function () {
    toggleAccordion($(this).parent());
    return false;
  }).on("keypress", function (e) {
    if (e.which === 13) {
      // enter key code
      toggleAccordion($(this).parent());
      return false;
    }
  });

  // Toggle the target accordion
  function toggleAccordion($accordion) {
    if ($accordion.hasClass(expandedClass)) {
      collapseAccordion($accordion);
    } else {
      expandAccordion($accordion);
    }
  }
  function expandAccordion($accordion) {
    $(".accordionUL li." + expandedClass + ">ul").slideUp();
    $(".accordionUL li").removeClass(expandedClass);
    $accordion.addClass(expandedClass).children('ul').slideDown();
  }

  // Close single accordion (and update group)
  function collapseAccordion($accordion) {
    $(".accordionUL li").removeClass(expandedClass);
    $accordion.children('ul').slideUp();
  }
});

// Toggle Sections
window.addEventListener('DOMContentLoaded', function () {
  var expandedClass = "active";
  $(".toggleAction").on("click", function () {
    toggleContent($(this).next(".toggleContent"));
    return false;
  }).on("keypress", function (e) {
    if (e.which === 13) {
      // enter key code
      toggleContent($(this).next(".toggleContent"));
      return false;
    }
  });

  // Open the First
  //$(".toggleAction").first().trigger('click');

  // Toggle the Content
  function toggleContent($toggleSection) {
    if ($toggleSection.parent().hasClass(expandedClass)) {
      collapseToggleContent($toggleSection);
    } else {
      //updateGroup($toggleSection);
      expandToggleContent($toggleSection);
    }
  }
  function updateGroup($toggleSection) {
    var groupName = $toggleSection.parent().attr("data-accordion-group");
    if (groupName) {
      $("[data-accordion-group='" + groupName + "']").each(function () {
        collapseToggleContent($(this).find(".toggleContent"));
      });
    }
  }
  function expandToggleContent($toggleSection) {
    $toggleSection.parent().addClass(expandedClass);
    $toggleSection.slideDown();
  }

  // Close single accordion (and update group)
  function collapseToggleContent($toggleSection) {
    $toggleSection.parent().removeClass(expandedClass);
    $toggleSection.slideUp();
  }
});

// Toggle Links
$(document).on('click', ".toggleOverlayLink", function (e) {
  var activeClass = "active";
  var inactiveClass = "inactive";
  var expandText = "Show Summary";
  var collapseText = "Hide Summary";
  var $toggleButton = $(this);
  var toggleContentID = $toggleButton.attr("aria-controls");
  //var $toggleContent = $("[id='" + toggleContentID + "']");
  var $toggleContent = $("#" + toggleContentID);
  if ($toggleButton.attr("aria-expanded") == "false") {
    $toggleButton.attr("aria-expanded", true);
    $toggleButton.attr("aria-label", collapseText);
    $toggleContent.addClass(activeClass);
    $toggleButton.parent(".itemContent").addClass(inactiveClass);
  } else {
    $toggleButton.attr("aria-expanded", false);
    $toggleButton.attr("aria-label", expandText);
    $toggleContent.removeClass(activeClass);
    $toggleButton.parent(".itemContent").removeClass(inactiveClass);
  }
});

// Expand Links
$(document).on('click', ".toggleExpandLink", function (e) {
  var activeClass = "expanded";
  var expandText = "Expand";
  var collapseText = "Collapse";
  var $toggleButton = $(this);
  var toggleContentID = $toggleButton.attr("aria-controls");
  //var $toggleContent = $("[id='" + toggleContentID + "']");
  var $toggleContent = $("#" + toggleContentID);
  if ($toggleButton.attr("aria-expanded") == "false") {
    $toggleButton.attr("aria-expanded", true);
    $toggleButton.attr("aria-label", collapseText);
    $toggleButton.parent().parent().addClass(activeClass);
    $toggleContent.addClass(activeClass);
  } else {
    $toggleButton.attr("aria-expanded", false);
    $toggleButton.attr("aria-label", expandText);
    $toggleButton.parent().parent().removeClass(activeClass);
    $toggleContent.removeClass(activeClass);
  }
});

// Our team position filters
window.addEventListener('DOMContentLoaded', function () {
  var $filters = $('.positionTypeFilters [data-filter]'),
    $filterItems = $('.filterable [data-position]');
  $filters.on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    $filters.removeClass('active');
    $this.addClass('active');
    var $filterPosition = $this.attr('data-filter');
    if ($filterPosition === 'all') {
      $filterItems.removeClass('is-selected').fadeOut().promise().done(function () {
        $filterItems.addClass('is-selected').fadeIn();
      });
    } else {
      $filterItems.removeClass('is-selected').fadeOut().promise().done(function () {
        $filterItems.filter('[data-position*= "' + $filterPosition + '"]').addClass('is-selected').fadeIn();
      });
    }
  });
  var $officeFilters = $('.officesFilters [data-filter]'),
    $officeFilterItems = $('.filterable [data-offices]');
  $officeFilters.on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    $officeFilters.removeClass('active');
    $this.addClass('active');
    var $filterOffice = $this.attr('data-filter');
    if ($filterOffice === 'all') {
      $officeFilterItems.removeClass('is-selected').fadeOut().promise().done(function () {
        $officeFilterItems.addClass('is-selected').fadeIn();
      });
    } else {
      $officeFilterItems.removeClass('is-selected').fadeOut().promise().done(function () {
        $officeFilterItems.filter('[data-offices*= "' + $filterOffice + '"]').addClass('is-selected').fadeIn();
      });
    }
  });
});

// Our Newsletter Year filters
window.addEventListener('DOMContentLoaded', function () {
  var $filters = $('#dateFilters [data-filter]'),
    $filterItems = $('.filterable [data-filter]');
  $filters.on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    $filters.removeClass('active');
    $this.addClass('active');
    var $filterPosition = $this.attr('data-filter');
    if ($filterPosition === 'all') {
      $filterItems.removeClass('is-selected').fadeOut().promise().done(function () {
        $filterItems.addClass('is-selected').fadeIn();
      });
    } else {
      $filterItems.removeClass('is-selected').fadeOut().promise().done(function () {
        $filterItems.filter('[data-filter*= "' + $filterPosition + '"]').addClass('is-selected').fadeIn();
      });
    }
  });
});

// Read more content
var $readMoreButtons = $('.readMoreAction');
var $fullTextWrappers = $('.readMoreText');
var buttonText;
var fullTextWrapper;
$fullTextWrappers.attr('hidden', true);
$readMoreButtons.removeAttr('hidden');

// add listener for each button
$readMoreButtons.each(function () {
  $(this).on('click', function () {
    fullTextWrapper = $(this).parent().find('.readMoreText');
    buttonText = $(this).find('.buttonText');
    console.log(fullTextWrapper);

    // change attributes and text if full text is shown/hidden
    if (!fullTextWrapper.attr('hidden')) {
      buttonText.text('Read more');
      fullTextWrapper.attr('hidden', true);
      $(this).attr('aria-expanded', false);
    } else {
      buttonText.text('Read less');
      fullTextWrapper.removeAttr('hidden');
      $(this).attr('aria-expanded', true);
    }
  });
});

/*Adjust Column Width - Articles*/
$(document).ready(function () {
  if ($('.related.publications ul li').length == 1) {
    $(".related.publications ul li").addClass("oneColumn");
  } else if ($('.related.publications ul li').length == 2) {
    $(".related.publications ul li").addClass("twoColumn");
  } else if ($('.related.publications ul li').length >= 3) {
    $(".related.publications ul li").addClass("twoColumn");
  }
});

/*Adjust Column Width - Cases*/
$(document).ready(function () {
  if ($('.related.case ul li').length == 2) {
    $(".related.case ul li").addClass("oneColumn");
  } else if ($('.related.case ul li').length == 4) {
    $(".related.case ul li").addClass("twoColumn");
  } else if ($('.related.case ul li').length == 6) {
    $(".related.case ul li").addClass("twoColumn");
  }
});

/*Adjust Column Width - News*/
$(document).ready(function () {
  if ($('.related.news ul li').length == 1) {
    $(".related.news ul li").addClass("oneColumn");
  } else if ($('.related.news ul li').length == 2) {
    $(".related.news ul li").addClass("twoColumn");
  } else if ($('.related.news ul li').length >= 3) {
    $(".related.news ul li").addClass("twoColumn");
  }
});

/*Adjust Column Width - Charity*/
$(document).ready(function () {
  if ($('.related.charity ul li').length == 1) {
    $(".related.charity ul li").addClass("oneColumn");
  } else if ($('.related.charity ul li').length == 2) {
    $(".related.charity ul li").addClass("twoColumn");
  } else if ($('.related.charity ul li').length >= 3) {
    $(".related.charity ul li").addClass("twoColumn");
  }
});

/*Adjust Column Width - Mandates*/
$(document).ready(function () {
  if ($('.related.mandate ul li').length == 2) {
    $(".related.mandate ul li").addClass("oneColumn");
  } else if ($('.related.mandate ul li').length == 4) {
    $(".related.mandate ul li").addClass("twoColumn");
  } else if ($('.related.mandate ul li').length == 6) {
    $(".related.mandate ul li").addClass("twoColumn");
  } else if ($('.related.mandate ul li').length == 8) {
    $(".related.mandate ul li").addClass("twoColumn");
  }
});

/*Adjust Column Width - Insolvency Cases*/
$(document).ready(function () {
  if ($('.related.insolvencycases ul li').length == 1) {
    $(".related.insolvencycases ul li").addClass("oneColumn");
  } else if ($('.related.insolvencycases ul li').length == 2) {
    $(".related.insolvencycases ul li").addClass("twoColumn");
  } else if ($('.related.insolvencycases ul li').length >= 3) {
    $(".related.insolvencycases ul li").addClass("twoColumn");
  }
  /*else if ($('.related.insolvencycases ul li').length == 4) {
      $(".related.insolvencycases ul li").addClass("twoColumn");
  }
  else if ($('.related.insolvencycases ul li').length == 6) {
      $(".related.insolvencycases ul li").addClass("twoColumn");
  }
  else if ($('.related.insolvencycases ul li').length == 8) {
      $(".related.insolvencycases ul li").addClass("twoColumn");
  }*/
});

/*Stick Left Side Bar Newsletter*/
window.addEventListener('DOMContentLoaded', function () {
  var $sticky = $('.sticky');
  var $stickyrStopper = $('.sticky-stopper');
  if (!!$sticky.offset()) {
    // make sure ".sticky" element exists

    var generalSidebarHeight = $sticky.innerHeight();
    var stickyTop = $sticky.offset().top;
    var stickOffset = 250;
    var stickyStopperPosition = $stickyrStopper.offset().top;
    var stopPoint = stickyStopperPosition - generalSidebarHeight - stickOffset;
    /*var stopPoint = stickyStopperPosition - 250;*/
    /*var diff = stopPoint + stickOffset;*/
    var diff = stopPoint + stickOffset;
    $(window).scroll(function () {
      // scroll event
      var windowTop = $(window).scrollTop(); // returns number

      if (stopPoint < windowTop) {
        /* $sticky.css({ position: 'absolute', top: diff });*/
        $sticky.css({
          position: 'fixed',
          top: stickOffset
        });
      } else if (stickyTop < windowTop + stickOffset) {
        /*  $sticky.css({ position: 'fixed', top: stickOffset });*/
        $sticky.css({
          position: 'fixed',
          top: stickOffset,
          width: '355px'
        });
      } else {
        /* $sticky.css({ position: 'absolute', top: 'initial' });*/
        $sticky.css({
          position: 'absolute',
          top: 0
        });
      }
    });
  }
  //jttest
});